export class HttpError extends Error {
  constructor(m: string, status?: number) {
    super(m)

    this.status = status || 500
  }

  status?: number
}
